module.exports = __webpack_public_path__ + "static/media/22.9f57860b.png";